




















































import Programacao from '@/views/Programacao.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { NavigationGuard } from 'vue-router'

@Component
export default class NavBar extends Vue {
  private closeMenuOnRouteChange: NavigationGuard = (to, from, next) => {
    const checkbox = document.getElementById('open-mmenu') as HTMLInputElement
    if (checkbox.checked) {
      checkbox.checked = false
    }
    next()
  }

  created() {
    this.$router.beforeEach(this.closeMenuOnRouteChange)    
  }

  mounted() {    
    window.addEventListener("resize", this.centralizar);
    setTimeout(this.centralizar, 300);
  }

  centralizar () {
    
    const logo    = document.getElementsByClassName('logo')[0];        
    const navBar  = document.getElementsByClassName('titulo-e-nav')[0];

    const largura_body    = window.innerWidth;
    const margin_logo     = parseInt(window.getComputedStyle(logo).marginRight);
    const largura_logo    = parseInt(window.getComputedStyle(logo).width);
    const largura_navBar  = parseInt(window.getComputedStyle(navBar).width);
        
    let largura_espacador = Math.floor((largura_body - largura_navBar) / 2);
    largura_espacador    -= largura_logo + margin_logo;

    const espacador       = document.getElementById('espacador');
    espacador.style.width = largura_espacador + "px";                
  }



}
